module.exports = __webpack_public_path__ + "img/BBDO_ATLANTA_logo.2e470027.svg";